
import Soulspace from './Soulspace';
import Navbar from './Navbar';
import { Link } from 'react-router-dom';

export default function Header() {
  return (
    <header className="bg-linear-to-r via-indigo-900 to-sky-900 text-white shadow-lg border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Logo + Branding - Always full width on mobile */}
        <div className="flex items-center justify-between py-4 border-b border-white/10 md:border-0">
          <div className="flex items-center gap-3 sm:gap-4">
            <img 
              src="/assets/images/logo b7.webp" 
              alt="Andlegur Logo" 
              className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 rounded-xl shadow-md object-contain shrink-0" 
            />
            <div className="flex flex-col justify-center min-w-0">
              <Link to="/" className="focus:outline-none group">
                <h1 className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-extrabold tracking-wide text-indigo-200 group-hover:underline truncate">
                  Andlegur
                </h1>
              </Link>
              {/* Always show first part, full tagline on larger screens */}
              <p className="text-sm sm:text-sm md:text-base lg:text-lg text-blue-100 italic font-medium leading-tight">
                <span>Your Space for Renewal</span>
                <span className="hidden md:inline">. Supporting Your Becoming</span>
              </p>
            </div>
          </div>
          
          {/* Mobile menu trigger moved to Navbar component */}
        </div>

        {/* Navigation Bar - Better responsive handling */}
        <div className="md:py-3">
          <Navbar />
        </div>
      </div>
    </header>
  );
}
